import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "@/views/Login"
import Home from "@/views/Home"
import Settings from "@/views/Settings"
import Accounting from '@/views/Accounting'
import Dashboards from '@/views/Dashboards'
import NewDashboard from '@/components/dashboards/NewDashboard'
import EditDashboard from '@/components/dashboards/EditDashboard'
import EditInternal from '@/components/dashboards/EditInternal'
import NewInternalLink from '@/components/dashboards/NewInternalLink'
import EditInternalLink from '@/components/dashboards/EditInternalLink'
import EditInternalSub from '@/components/dashboards/EditInternalSub'
import NewInternalSub from '@/components/dashboards/NewInternalSub'
import * as firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/accounting",
    name: "Accounting",
    component: Accounting,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/dashboards",
    name: "Dashboards",
    component: Dashboards,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/dashboards/new",
    name: "NewDashboard",
    component: NewDashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/dashboards/internal",
    name: "EditInternal",
    component: EditInternal,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/dashboards/internal/new",
    name: "NewLink",
    component: NewInternalLink,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/dashboards/internal/:link_slug/new",
    name: "NewInternalSub",
    component: NewInternalSub,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/dashboards/internal/:link_slug",
    name: "EditInternalLink",
    component: EditInternalLink,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/dashboards/internal/:link_slug/:sub_slug",
    name: "EditInternalSub",
    component: EditInternalSub,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/dashboards/:dashboard_slug",
    name: "EditDashboard",
    component: EditDashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    meta: {
      requiresAuth: true
    }
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated  = firebase.auth().currentUser
  if(requiresAuth && !isAuthenticated){
    next('/login')
  } else{
    next()
  }
})

export default router
